"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import CircleLoader from "@/components/distribution-plan-tool/common/CircleLoader";
import { QueryKey, ReactQueryWrapperContext } from "@/components/react-query-wrapper/ReactQueryWrapper";
import UserRateAdjustmentHelper from "@/components/user/utils/rate/UserRateAdjustmentHelper";
import { ApiProfileRepRatesState, RatingStats } from "@/entities/IProfile";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
import { ApiProfileProxyActionType } from "@/generated/models/ApiProfileProxyActionType";
import { getStringAsNumberOrZero } from "@/helpers/Helpers";
import { commonApiFetch, commonApiPost } from "@/services/api/common-api";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useContext, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { motion } from "framer-motion";
import { useClickAway, useKeyPressEvent } from "react-use";
import UserPageRepModifyModalHeader from "./UserPageRepModifyModalHeader";
import UserPageRepModifyModalRaterStats from "./UserPageRepModifyModalRaterStats";
interface ApiAddRepRatingToProfileRequest {
  readonly amount: number;
  readonly category: string;
}
export default function UserPageRepModifyModal(t0) {
  const $ = _c(181);
  const {
    onClose,
    profile,
    category
  } = t0;
  const {
    onProfileRepModify
  } = useContext(ReactQueryWrapperContext);
  const {
    requestAuth,
    setToast,
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  const t1 = activeProfileProxy?.created_by.handle;
  const t2 = profile?.handle;
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = [QueryKey.PROFILE_REP_RATINGS, {
      rater: t1,
      handleOrWallet: t2
    }];
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== activeProfileProxy || $[4] !== profile?.query) {
    t4 = async () => await commonApiFetch({
      endpoint: `profiles/${profile?.query}/rep/ratings/received`,
      params: activeProfileProxy?.created_by.handle ? {
        rater: activeProfileProxy.created_by.handle
      } : {}
    });
    $[3] = activeProfileProxy;
    $[4] = profile?.query;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = !!activeProfileProxy?.created_by.handle;
  let t6;
  if ($[6] !== t3 || $[7] !== t4 || $[8] !== t5) {
    t6 = {
      queryKey: t3,
      queryFn: t4,
      enabled: t5
    };
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const {
    data: proxyGrantorRepRates
  } = useQuery(t6);
  const t7 = connectedProfile?.handle;
  const t8 = profile?.handle;
  let t9;
  if ($[10] !== t7 || $[11] !== t8) {
    t9 = [QueryKey.PROFILE_REP_RATINGS, {
      rater: t7,
      handleOrWallet: t8
    }];
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== connectedProfile?.handle || $[14] !== profile?.query) {
    t10 = async () => await commonApiFetch({
      endpoint: `profiles/${profile?.query}/rep/ratings/received`,
      params: connectedProfile?.handle ? {
        rater: connectedProfile?.handle
      } : {}
    });
    $[13] = connectedProfile?.handle;
    $[14] = profile?.query;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const t11 = !!connectedProfile?.handle;
  let t12;
  if ($[16] !== t10 || $[17] !== t11 || $[18] !== t9) {
    t12 = {
      queryKey: t9,
      queryFn: t10,
      enabled: t11
    };
    $[16] = t10;
    $[17] = t11;
    $[18] = t9;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  const {
    data: connectedProfileRepRates
  } = useQuery(t12);
  let t13;
  if ($[20] !== activeProfileProxy?.actions) {
    t13 = () => {
      const repProxy = activeProfileProxy?.actions.find(_temp);
      if (!repProxy) {
        return null;
      }
      return Math.max((repProxy.credit_amount ?? 0) - (repProxy.credit_spent ?? 0), 0);
    };
    $[20] = activeProfileProxy?.actions;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  const getProxyAvailableCredit = t13;
  const [proxyAvailableCredit, setProxyAvailableCredit] = useState(getProxyAvailableCredit());
  let t14;
  if ($[22] !== getProxyAvailableCredit) {
    t14 = () => setProxyAvailableCredit(getProxyAvailableCredit());
    $[22] = getProxyAvailableCredit;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== activeProfileProxy) {
    t15 = [activeProfileProxy];
    $[24] = activeProfileProxy;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  useEffect(t14, t15);
  let t16;
  if ($[26] !== activeProfileProxy || $[27] !== category || $[28] !== connectedProfileRepRates || $[29] !== proxyGrantorRepRates) {
    t16 = () => {
      if (activeProfileProxy && proxyGrantorRepRates) {
        const target = proxyGrantorRepRates.rating_stats.find(s => s.category === category);
        return target ?? {
          category,
          rating: 0,
          contributor_count: 0,
          rater_contribution: 0
        };
      }
      if (activeProfileProxy) {
        return null;
      }
      if (connectedProfileRepRates) {
        const target_0 = connectedProfileRepRates.rating_stats.find(s_0 => s_0.category === category);
        return target_0 ?? {
          category,
          rating: 0,
          contributor_count: 0,
          rater_contribution: 0
        };
      }
      return null;
    };
    $[26] = activeProfileProxy;
    $[27] = category;
    $[28] = connectedProfileRepRates;
    $[29] = proxyGrantorRepRates;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  const getRepState = t16;
  let t17;
  if ($[31] !== getRepState) {
    t17 = getRepState();
    $[31] = getRepState;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  const [repState, setRepState] = useState(t17);
  let t18;
  if ($[33] !== getRepState) {
    t18 = getRepState()?.rater_contribution ?? 0;
    $[33] = getRepState;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  const [adjustedRatingStr, setAdjustedRatingStr] = useState(`${t18}`);
  let t19;
  if ($[35] !== activeProfileProxy || $[36] !== connectedProfileRepRates?.rep_rates_left_for_rater || $[37] !== proxyGrantorRepRates?.rep_rates_left_for_rater) {
    t19 = () => {
      if (activeProfileProxy) {
        return proxyGrantorRepRates?.rep_rates_left_for_rater ?? 0;
      }
      return connectedProfileRepRates?.rep_rates_left_for_rater ?? 0;
    };
    $[35] = activeProfileProxy;
    $[36] = connectedProfileRepRates?.rep_rates_left_for_rater;
    $[37] = proxyGrantorRepRates?.rep_rates_left_for_rater;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  const getHeroAvailableRep = t19;
  let t20;
  if ($[39] !== getHeroAvailableRep) {
    t20 = getHeroAvailableRep();
    $[39] = getHeroAvailableRep;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  const [heroAvailableRep, setHeroAvailableRep] = useState(t20);
  let t21;
  if ($[41] !== getHeroAvailableRep) {
    t21 = () => setHeroAvailableRep(getHeroAvailableRep());
    $[41] = getHeroAvailableRep;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] !== activeProfileProxy || $[44] !== connectedProfileRepRates || $[45] !== proxyGrantorRepRates) {
    t22 = [activeProfileProxy, proxyGrantorRepRates, connectedProfileRepRates];
    $[43] = activeProfileProxy;
    $[44] = connectedProfileRepRates;
    $[45] = proxyGrantorRepRates;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  useEffect(t21, t22);
  let t23;
  if ($[47] !== heroAvailableRep || $[48] !== proxyAvailableCredit || $[49] !== repState?.rater_contribution) {
    t23 = () => {
      const currentRep = repState?.rater_contribution ?? 0;
      const minHeroRep = 0 - (Math.abs(currentRep) + heroAvailableRep);
      if (typeof proxyAvailableCredit !== "number") {
        return minHeroRep;
      }
      const minProxyRep = currentRep - proxyAvailableCredit;
      return Math.abs(minHeroRep) < Math.abs(minProxyRep) ? minHeroRep : minProxyRep;
    };
    $[47] = heroAvailableRep;
    $[48] = proxyAvailableCredit;
    $[49] = repState?.rater_contribution;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  const getMinValue = t23;
  let t24;
  if ($[51] !== heroAvailableRep || $[52] !== proxyAvailableCredit || $[53] !== repState?.rater_contribution) {
    t24 = () => {
      const currentRep_0 = repState?.rater_contribution ?? 0;
      const maxHeroRep = Math.abs(currentRep_0) + heroAvailableRep;
      if (typeof proxyAvailableCredit !== "number") {
        return maxHeroRep;
      }
      const maxProxyRep = currentRep_0 + proxyAvailableCredit;
      return Math.min(maxHeroRep, maxProxyRep);
    };
    $[51] = heroAvailableRep;
    $[52] = proxyAvailableCredit;
    $[53] = repState?.rater_contribution;
    $[54] = t24;
  } else {
    t24 = $[54];
  }
  const getMaxValue = t24;
  let t25;
  if ($[55] !== getMaxValue || $[56] !== getMinValue) {
    t25 = () => ({
      min: getMinValue(),
      max: getMaxValue()
    });
    $[55] = getMaxValue;
    $[56] = getMinValue;
    $[57] = t25;
  } else {
    t25 = $[57];
  }
  const getMinMaxValues = t25;
  let t26;
  if ($[58] !== getMinMaxValues) {
    t26 = getMinMaxValues();
    $[58] = getMinMaxValues;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  const [minMaxValues, setMinMaxValues] = useState(t26);
  let t27;
  if ($[60] !== getRepState) {
    t27 = () => {
      const newState = getRepState();
      setRepState(newState);
      setAdjustedRatingStr(`${newState?.rater_contribution ?? 0}`);
    };
    $[60] = getRepState;
    $[61] = t27;
  } else {
    t27 = $[61];
  }
  let t28;
  if ($[62] !== activeProfileProxy || $[63] !== connectedProfileRepRates || $[64] !== heroAvailableRep || $[65] !== proxyGrantorRepRates) {
    t28 = [proxyGrantorRepRates, activeProfileProxy, connectedProfileRepRates, heroAvailableRep];
    $[62] = activeProfileProxy;
    $[63] = connectedProfileRepRates;
    $[64] = heroAvailableRep;
    $[65] = proxyGrantorRepRates;
    $[66] = t28;
  } else {
    t28 = $[66];
  }
  useEffect(t27, t28);
  let t29;
  if ($[67] !== getMinMaxValues) {
    t29 = () => setMinMaxValues(getMinMaxValues());
    $[67] = getMinMaxValues;
    $[68] = t29;
  } else {
    t29 = $[68];
  }
  let t30;
  if ($[69] !== proxyAvailableCredit || $[70] !== proxyGrantorRepRates || $[71] !== repState) {
    t30 = [repState, proxyGrantorRepRates, proxyAvailableCredit];
    $[69] = proxyAvailableCredit;
    $[70] = proxyGrantorRepRates;
    $[71] = repState;
    $[72] = t30;
  } else {
    t30 = $[72];
  }
  useEffect(t29, t30);
  const inputRef = useRef(null);
  let t31;
  let t32;
  if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = () => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    };
    t32 = [inputRef];
    $[73] = t31;
    $[74] = t32;
  } else {
    t31 = $[73];
    t32 = $[74];
  }
  useEffect(t31, t32);
  const modalRef = useRef(null);
  useClickAway(modalRef, onClose);
  useKeyPressEvent("Escape", onClose);
  const [isMounted, setIsMounted] = useState(false);
  let t33;
  let t34;
  if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = () => {
      setIsMounted(true);
    };
    t34 = [];
    $[75] = t33;
    $[76] = t34;
  } else {
    t33 = $[75];
    t34 = $[76];
  }
  useEffect(t33, t34);
  let t35;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = [];
    $[77] = t35;
  } else {
    t35 = $[77];
  }
  useEffect(_temp2, t35);
  const getValueStr = _temp3;
  let t36;
  if ($[78] !== adjustedRatingStr || $[79] !== minMaxValues) {
    t36 = () => {
      const {
        min,
        max
      } = minMaxValues;
      const valueAsNumber = getStringAsNumberOrZero(adjustedRatingStr);
      if (valueAsNumber > max) {
        setAdjustedRatingStr(`${max}`);
        return;
      }
      if (valueAsNumber < min) {
        setAdjustedRatingStr(`${min}`);
      }
    };
    $[78] = adjustedRatingStr;
    $[79] = minMaxValues;
    $[80] = t36;
  } else {
    t36 = $[80];
  }
  const adjustStrValueToMinMax = t36;
  let t37;
  if ($[81] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = event => {
      const inputValue = event.currentTarget.value;
      const strCIC = ["-0", "0-"].includes(inputValue) ? "-" : inputValue;
      if (/^-?\d*$/.test(strCIC)) {
        const newCicValue = getValueStr(strCIC);
        setAdjustedRatingStr(newCicValue);
      }
    };
    $[81] = t37;
  } else {
    t37 = $[81];
  }
  const onValueChange = t37;
  let t38;
  if ($[82] !== adjustedRatingStr || $[83] !== minMaxValues) {
    t38 = () => {
      const {
        min: min_0,
        max: max_0
      } = minMaxValues;
      const valueAsNumber_0 = getStringAsNumberOrZero(adjustedRatingStr);
      if (valueAsNumber_0 > max_0) {
        return false;
      }
      if (valueAsNumber_0 < min_0) {
        return false;
      }
      return true;
    };
    $[82] = adjustedRatingStr;
    $[83] = minMaxValues;
    $[84] = t38;
  } else {
    t38 = $[84];
  }
  const getIsValidValue = t38;
  const [isValidValue, setIsValidValue] = useState(getIsValidValue());
  let t39;
  if ($[85] !== getIsValidValue) {
    t39 = () => setIsValidValue(getIsValidValue());
    $[85] = getIsValidValue;
    $[86] = t39;
  } else {
    t39 = $[86];
  }
  let t40;
  if ($[87] !== adjustedRatingStr) {
    t40 = [adjustedRatingStr];
    $[87] = adjustedRatingStr;
    $[88] = t40;
  } else {
    t40 = $[88];
  }
  useEffect(t39, t40);
  let t41;
  if ($[89] !== adjustedRatingStr) {
    t41 = getStringAsNumberOrZero(adjustedRatingStr);
    $[89] = adjustedRatingStr;
    $[90] = t41;
  } else {
    t41 = $[90];
  }
  const [newRating, setNewRating] = useState(t41);
  let t42;
  let t43;
  if ($[91] !== adjustedRatingStr) {
    t42 = () => {
      setNewRating(getStringAsNumberOrZero(adjustedRatingStr));
    };
    t43 = [adjustedRatingStr];
    $[91] = adjustedRatingStr;
    $[92] = t42;
    $[93] = t43;
  } else {
    t42 = $[92];
    t43 = $[93];
  }
  useEffect(t42, t43);
  const [haveChanged, setHaveChanged] = useState(newRating !== repState?.rater_contribution);
  let t44;
  if ($[94] !== newRating || $[95] !== repState?.rater_contribution) {
    t44 = () => {
      setHaveChanged(newRating !== repState?.rater_contribution);
    };
    $[94] = newRating;
    $[95] = repState?.rater_contribution;
    $[96] = t44;
  } else {
    t44 = $[96];
  }
  let t45;
  if ($[97] !== newRating || $[98] !== repState) {
    t45 = [newRating, repState];
    $[97] = newRating;
    $[98] = repState;
    $[99] = t45;
  } else {
    t45 = $[99];
  }
  useEffect(t44, t45);
  let t46;
  if ($[100] !== haveChanged || $[101] !== isValidValue || $[102] !== repState) {
    t46 = () => {
      if (!repState) {
        return true;
      }
      if (!haveChanged) {
        return true;
      }
      if (!isValidValue) {
        return true;
      }
      return false;
    };
    $[100] = haveChanged;
    $[101] = isValidValue;
    $[102] = repState;
    $[103] = t46;
  } else {
    t46 = $[103];
  }
  const getIsSaveDisabled = t46;
  const [isSaveDisabled, setIsSaveDisabled] = useState(getIsSaveDisabled());
  let t47;
  if ($[104] !== getIsSaveDisabled) {
    t47 = () => {
      setIsSaveDisabled(getIsSaveDisabled());
    };
    $[104] = getIsSaveDisabled;
    $[105] = t47;
  } else {
    t47 = $[105];
  }
  let t48;
  if ($[106] !== haveChanged || $[107] !== isValidValue || $[108] !== repState) {
    t48 = [haveChanged, isValidValue, repState];
    $[106] = haveChanged;
    $[107] = isValidValue;
    $[108] = repState;
    $[109] = t48;
  } else {
    t48 = $[109];
  }
  useEffect(t47, t48);
  const [mutating, setMutating] = useState(false);
  let t49;
  if ($[110] !== profile?.query) {
    t49 = async t50 => {
      const {
        amount,
        category: category_0
      } = t50;
      return await commonApiPost({
        endpoint: `profiles/${profile?.query}/rep/rating`,
        body: {
          amount,
          category: category_0
        }
      });
    };
    $[110] = profile?.query;
    $[111] = t49;
  } else {
    t49 = $[111];
  }
  let t50;
  if ($[112] !== activeProfileProxy || $[113] !== connectedProfile || $[114] !== onClose || $[115] !== onProfileRepModify || $[116] !== profile || $[117] !== setToast) {
    t50 = () => {
      setToast({
        message: "Rep updated.",
        type: "success"
      });
      onProfileRepModify({
        targetProfile: profile,
        connectedProfile,
        profileProxy: activeProfileProxy ?? null
      });
      onClose();
    };
    $[112] = activeProfileProxy;
    $[113] = connectedProfile;
    $[114] = onClose;
    $[115] = onProfileRepModify;
    $[116] = profile;
    $[117] = setToast;
    $[118] = t50;
  } else {
    t50 = $[118];
  }
  let t51;
  if ($[119] !== setToast) {
    t51 = error => {
      setToast({
        message: error as unknown as string,
        type: "error"
      });
    };
    $[119] = setToast;
    $[120] = t51;
  } else {
    t51 = $[120];
  }
  let t52;
  if ($[121] === Symbol.for("react.memo_cache_sentinel")) {
    t52 = () => {
      setMutating(false);
    };
    $[121] = t52;
  } else {
    t52 = $[121];
  }
  let t53;
  if ($[122] !== t49 || $[123] !== t50 || $[124] !== t51) {
    t53 = {
      mutationFn: t49,
      onSuccess: t50,
      onError: t51,
      onSettled: t52
    };
    $[122] = t49;
    $[123] = t50;
    $[124] = t51;
    $[125] = t53;
  } else {
    t53 = $[125];
  }
  const addRepMutation = useMutation(t53);
  let t54;
  if ($[126] !== addRepMutation || $[127] !== category || $[128] !== haveChanged || $[129] !== mutating || $[130] !== newRating || $[131] !== requestAuth || $[132] !== setToast) {
    t54 = async event_0 => {
      event_0.preventDefault();
      if (mutating) {
        return;
      }
      setMutating(true);
      const {
        success
      } = await requestAuth();
      if (!success) {
        setToast({
          message: "You must be logged in.",
          type: "error"
        });
        setMutating(false);
        return;
      }
      if (!haveChanged) {
        setMutating(false);
        return;
      }
      await addRepMutation.mutateAsync({
        amount: newRating,
        category
      });
    };
    $[126] = addRepMutation;
    $[127] = category;
    $[128] = haveChanged;
    $[129] = mutating;
    $[130] = newRating;
    $[131] = requestAuth;
    $[132] = setToast;
    $[133] = t54;
  } else {
    t54 = $[133];
  }
  const onSubmit = t54;
  if (!isMounted || globalThis.document === undefined) {
    return null;
  }
  let t55;
  let t56;
  let t57;
  if ($[134] === Symbol.for("react.memo_cache_sentinel")) {
    t55 = {
      opacity: 0
    };
    t56 = {
      opacity: 1
    };
    t57 = {
      opacity: 0
    };
    $[134] = t55;
    $[135] = t56;
    $[136] = t57;
  } else {
    t55 = $[134];
    t56 = $[135];
    t57 = $[136];
  }
  let t58;
  if ($[137] === Symbol.for("react.memo_cache_sentinel")) {
    t58 = <div className="tw-absolute tw-inset-0 tw-bg-gray-600 tw-bg-opacity-50 tw-backdrop-blur-[1px]" />;
    $[137] = t58;
  } else {
    t58 = $[137];
  }
  const t59 = profile.query ?? profile.handle ?? profile.display;
  let t60;
  if ($[138] !== onClose || $[139] !== t59) {
    t60 = <UserPageRepModifyModalHeader handleOrWallet={t59} onClose={onClose} />;
    $[138] = onClose;
    $[139] = t59;
    $[140] = t60;
  } else {
    t60 = $[140];
  }
  let t61;
  if ($[141] !== heroAvailableRep || $[142] !== minMaxValues || $[143] !== repState) {
    t61 = repState && <UserPageRepModifyModalRaterStats repState={repState} minMaxValues={minMaxValues} heroAvailableCredit={heroAvailableRep} />;
    $[141] = heroAvailableRep;
    $[142] = minMaxValues;
    $[143] = repState;
    $[144] = t61;
  } else {
    t61 = $[144];
  }
  let t62;
  if ($[145] !== category) {
    t62 = <label className="tw-block tw-text-sm tw-font-normal tw-leading-5 tw-text-iron-400">Your total Rep for {category}:</label>;
    $[145] = category;
    $[146] = t62;
  } else {
    t62 = $[146];
  }
  let t63;
  if ($[147] === Symbol.for("react.memo_cache_sentinel")) {
    t63 = <svg className="tw-w-3.5 tw-h-3.5 tw-flex-shrink-0 tw-text-iron-500" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[147] = t63;
  } else {
    t63 = $[147];
  }
  let t64;
  if ($[148] === Symbol.for("react.memo_cache_sentinel")) {
    t64 = <span className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-bg-iron-900 tw-rounded-l-lg tw-border tw-border-solid tw-border-iron-700 tw-px-3">{t63}<svg className="tw-w-3.5 tw-h-3.5 tw-flex-shrink-0 tw-text-iron-500" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M5 12H19" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" /></svg></span>;
    $[148] = t64;
  } else {
    t64 = $[148];
  }
  const t65 = `${isValidValue ? "focus:tw-ring-primary-400" : "focus:tw-ring-red"} tw-appearance-none -tw-ml-0.5 tw-block tw-w-full tw-rounded-l-none tw-rounded-r-lg tw-border-0 tw-py-3 tw-px-3 tw-bg-iron-900 focus:tw-bg-iron-950 tw-text-iron-300 tw-font-medium tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-700 hover:tw-ring-iron-600 placeholder:tw-text-iron-500 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset tw-text-base tw-transition tw-duration-300 tw-ease-out`;
  let t66;
  if ($[149] !== adjustStrValueToMinMax || $[150] !== adjustedRatingStr || $[151] !== t65) {
    t66 = <div className="tw-relative tw-flex tw-mt-1.5">{t64}<input ref={inputRef} type="text" required={true} autoComplete="off" value={adjustedRatingStr} onChange={onValueChange} onBlur={adjustStrValueToMinMax} className={t65} /></div>;
    $[149] = adjustStrValueToMinMax;
    $[150] = adjustedRatingStr;
    $[151] = t65;
    $[152] = t66;
  } else {
    t66 = $[152];
  }
  const t67 = repState?.rater_contribution ?? 0;
  let t68;
  if ($[153] !== adjustedRatingStr) {
    t68 = getStringAsNumberOrZero(adjustedRatingStr);
    $[153] = adjustedRatingStr;
    $[154] = t68;
  } else {
    t68 = $[154];
  }
  let t69;
  if ($[155] !== t67 || $[156] !== t68) {
    t69 = <UserRateAdjustmentHelper inLineValues={true} originalValue={t67} adjustedValue={t68} adjustmentType="Rep" />;
    $[155] = t67;
    $[156] = t68;
    $[157] = t69;
  } else {
    t69 = $[157];
  }
  let t70;
  if ($[158] !== t62 || $[159] !== t66 || $[160] !== t69) {
    t70 = <div>{t62}{t66}{t69}</div>;
    $[158] = t62;
    $[159] = t66;
    $[160] = t69;
    $[161] = t70;
  } else {
    t70 = $[161];
  }
  const t71 = `${!isSaveDisabled ? "tw-cursor-pointer hover:tw-bg-primary-600 hover:tw-border-primary-600" : "tw-cursor-not-allowed tw-opacity-50"} tw-w-full sm:tw-w-auto tw-bg-primary-500 tw-border-primary-500 tw-px-4 tw-py-3 tw-text-sm tw-font-semibold tw-text-white tw-border tw-border-solid  tw-rounded-lg  tw-transition tw-duration-300 tw-ease-out`;
  let t72;
  if ($[162] !== mutating) {
    t72 = mutating ? <div className="tw-w-8"><CircleLoader /></div> : <>Save</>;
    $[162] = mutating;
    $[163] = t72;
  } else {
    t72 = $[163];
  }
  let t73;
  if ($[164] !== isSaveDisabled || $[165] !== t71 || $[166] !== t72) {
    t73 = <button type="submit" disabled={isSaveDisabled} className={t71}>{t72}</button>;
    $[164] = isSaveDisabled;
    $[165] = t71;
    $[166] = t72;
    $[167] = t73;
  } else {
    t73 = $[167];
  }
  let t74;
  if ($[168] !== onClose) {
    t74 = <button onClick={onClose} type="button" className="tw-mt-3 sm:tw-mt-0 tw-w-full sm:tw-w-auto tw-cursor-pointer tw-bg-iron-900 tw-px-4 tw-py-3 tw-text-sm tw-font-semibold tw-text-white tw-border tw-border-solid tw-border-iron-700 tw-rounded-lg hover:tw-bg-iron-800 tw-transition tw-duration-300 tw-ease-out">Cancel</button>;
    $[168] = onClose;
    $[169] = t74;
  } else {
    t74 = $[169];
  }
  let t75;
  if ($[170] !== t73 || $[171] !== t74) {
    t75 = <div className="tw-mt-8"><div className="sm:tw-flex sm:tw-flex-row-reverse tw-gap-x-3">{t73}{t74}</div></div>;
    $[170] = t73;
    $[171] = t74;
    $[172] = t75;
  } else {
    t75 = $[172];
  }
  let t76;
  if ($[173] !== onSubmit || $[174] !== t70 || $[175] !== t75) {
    t76 = <form onSubmit={onSubmit} className="tw-mt-4">{t70}{t75}</form>;
    $[173] = onSubmit;
    $[174] = t70;
    $[175] = t75;
    $[176] = t76;
  } else {
    t76 = $[176];
  }
  let t77;
  if ($[177] !== t60 || $[178] !== t61 || $[179] !== t76) {
    t77 = createPortal(<motion.div initial={t55} animate={t56} exit={t57} className="tailwind-scope tw-fixed tw-inset-0 tw-z-[1100] tw-cursor-default">{t58}<div className="tw-relative tw-flex tw-min-h-full tw-w-full tw-overflow-y-auto tw-items-end tw-justify-center tw-text-center sm:tw-items-center tw-p-2 lg:tw-p-0"><div ref={modalRef} className="sm:tw-max-w-md tw-relative tw-w-full tw-transform tw-rounded-xl tw-bg-iron-950 tw-text-left tw-shadow-xl tw-transition-all tw-duration-500 sm:tw-w-full tw-p-6">{t60}{t61}{t76}</div></div></motion.div>, document.body);
    $[177] = t60;
    $[178] = t61;
    $[179] = t76;
    $[180] = t77;
  } else {
    t77 = $[180];
  }
  return t77;
}
function _temp3(value) {
  if (value.length > 1 && value.startsWith("0")) {
    return value.slice(1);
  }
  return value;
}
function _temp2() {
  if (globalThis.document === undefined || globalThis.window === undefined) {
    return;
  }
  const currentWindow = globalThis.window;
  const previousOverflow = document.body.style.overflow;
  const previousPaddingRight = document.body.style.paddingRight;
  const scrollbarGap = currentWindow.innerWidth - document.documentElement.clientWidth;
  document.body.style.overflow = "hidden";
  if (scrollbarGap > 0) {
    document.body.style.paddingRight = `${scrollbarGap}px`;
  }
  return () => {
    document.body.style.overflow = previousOverflow;
    document.body.style.paddingRight = previousPaddingRight;
  };
}
function _temp(a) {
  return a.action_type === ApiProfileProxyActionType.AllocateRep;
}